export class PedidoOutERP {
    pedidoId? : number;
    pedidoDetalleId?:number;
    almacenId? : number;
    codigoErp? : number;
    usuarioId? : number;
    formaPagoId? : number;
    observaciones? : string;
    telefonoCliente? : string;
    estatus?:string;
    precioErp?:number;
	porcentajeDesctoEcommerce?:number;
	precioFinalEcommerce?:number;
    nombreCliente?:string;
    idUsuario?:number;
}